/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CalendarEvent,
  CandidateMessage,
  CandidateProgress,
  UserPersonalData,
} from '../models/index';
import {
    CalendarEventFromJSON,
    CalendarEventToJSON,
    CandidateMessageFromJSON,
    CandidateMessageToJSON,
    CandidateProgressFromJSON,
    CandidateProgressToJSON,
    UserPersonalDataFromJSON,
    UserPersonalDataToJSON,
} from '../models/index';

export interface DisableExtendedHelpOnStartRequest {
    nodeid?: number;
}

export interface GetAppointmentRequest {
    appointmentId?: string;
}

export interface GetCandidateMessagesRequest {
    meetingId?: string;
}

export interface GetProgressRequest {
    includeAttendedEvents?: boolean;
    includeAttendedPersonalMeetings?: boolean;
    includeModules?: boolean;
    includeCompletedModules?: boolean;
}

export interface SetNumberOfJobInterviewsRequest {
    count?: number;
}

/**
 * 
 */
export class PersonalDataApi extends runtime.BaseAPI {

    /**
     */
    async disableExtendedHelpOnStartRaw(requestParameters: DisableExtendedHelpOnStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.nodeid !== undefined) {
            queryParameters['nodeid'] = requestParameters.nodeid;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/PersonalDataApi/DisableExtendedHelpOnStart`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async disableExtendedHelpOnStart(requestParameters: DisableExtendedHelpOnStartRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.disableExtendedHelpOnStartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAppointmentRaw(requestParameters: GetAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalendarEvent>> {
        const queryParameters: any = {};

        if (requestParameters.appointmentId !== undefined) {
            queryParameters['appointmentId'] = requestParameters.appointmentId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/PersonalDataApi/GetAppointment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalendarEventFromJSON(jsonValue));
    }

    /**
     */
    async getAppointment(requestParameters: GetAppointmentRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalendarEvent> {
        const response = await this.getAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCandidateMessagesRaw(requestParameters: GetCandidateMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CandidateMessage>>> {
        const queryParameters: any = {};

        if (requestParameters.meetingId !== undefined) {
            queryParameters['meetingId'] = requestParameters.meetingId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/PersonalDataApi/GetCandidateMessages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CandidateMessageFromJSON));
    }

    /**
     */
    async getCandidateMessages(requestParameters: GetCandidateMessagesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CandidateMessage>> {
        const response = await this.getCandidateMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPersonalDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserPersonalData>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/PersonalDataApi/GetPersonalData`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPersonalDataFromJSON(jsonValue));
    }

    /**
     */
    async getPersonalData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserPersonalData> {
        const response = await this.getPersonalDataRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getProgressRaw(requestParameters: GetProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CandidateProgress>> {
        const queryParameters: any = {};

        if (requestParameters.includeAttendedEvents !== undefined) {
            queryParameters['IncludeAttendedEvents'] = requestParameters.includeAttendedEvents;
        }

        if (requestParameters.includeAttendedPersonalMeetings !== undefined) {
            queryParameters['IncludeAttendedPersonalMeetings'] = requestParameters.includeAttendedPersonalMeetings;
        }

        if (requestParameters.includeModules !== undefined) {
            queryParameters['IncludeModules'] = requestParameters.includeModules;
        }

        if (requestParameters.includeCompletedModules !== undefined) {
            queryParameters['IncludeCompletedModules'] = requestParameters.includeCompletedModules;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/PersonalDataApi/GetProgress`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CandidateProgressFromJSON(jsonValue));
    }

    /**
     */
    async getProgress(requestParameters: GetProgressRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CandidateProgress> {
        const response = await this.getProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setNumberOfJobInterviewsRaw(requestParameters: SetNumberOfJobInterviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters.count !== undefined) {
            queryParameters['count'] = requestParameters.count;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/PersonalDataApi/SetNumberOfJobInterviews`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async setNumberOfJobInterviews(requestParameters: SetNumberOfJobInterviewsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.setNumberOfJobInterviewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
